import type { FC } from 'react';
import { useFetchAllCache, useFetchOneCache } from '../../hooks/use-cache.js';
import { usePromise } from '../../hooks/use-promise.js';
import {
  FieldLoadError,
  FieldLoading,
  FieldNotFound,
} from '../loading/index.js';

interface Props {
  dataType: string;
  id: unknown;
  notFoundFactory?: () => JSX.Element;
  // biome-ignore lint/suspicious/noExplicitAny: needed
  renderFactory: (data: any) => JSX.Element;
}

const DEFAULT_NOT_FOUND = (): JSX.Element => <FieldNotFound />;

export const FetchOne: FC<Props> = ({
  dataType,
  id,
  renderFactory,
  notFoundFactory = DEFAULT_NOT_FOUND,
}) => {
  const cache = useFetchOneCache(dataType);
  const [result, , state] = usePromise(() => cache.one(id), [cache, id]);

  if (state === 'pending') return <FieldLoading />;
  if (state === 'rejected') return <FieldLoadError />;
  if (!result) return notFoundFactory();

  return renderFactory(result);
};

export const FetchOneOfAll: FC<Props> = ({
  dataType,
  id,
  renderFactory,
  notFoundFactory = DEFAULT_NOT_FOUND,
}) => {
  const cache = useFetchAllCache(dataType);
  const [result, , state] = usePromise(() => cache.one(id), [cache, id]);

  if (state === 'pending') return <FieldLoading />;
  if (state === 'rejected') return <FieldLoadError />;
  if (!result) return notFoundFactory();

  return renderFactory(result);
};
